import { Static, Type } from '@sinclair/typebox';

export const MessageResponseSchema = Type.Object({
  message: Type.String(),
});
export type MessageResponseObject = Static<typeof MessageResponseSchema>;
